module.exports = __webpack_public_path__ + "img/mi-sos-scan.79702cb0.png";